document.addEventListener('DOMContentLoaded', function () {
  const countdownWrappers = document.querySelectorAll('.countdown-timer-wrapper');

  countdownWrappers.forEach(function (countdownWrapper) {
    const endDateTimeStr = countdownWrapper.getAttribute('data-end-date');
    if (!endDateTimeStr) return;

    const endDateTime = new Date(endDateTimeStr).getTime();

    function splitDigits(element, value) {
      // Clear existing content
      element.innerHTML = '';
      // Loop through each digit and add as a <span>
      value.toString().padStart(2, '0').split('').forEach(function (digit) {
        const span = document.createElement('span');
        span.textContent = digit;
        element.appendChild(span);
      });
    }

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endDateTime - now;

      if (distance <= 0) {
        countdownWrapper.style.display = "none";

        const countdownSection = countdownWrapper.closest('.countdown__section');
        if (countdownSection) countdownSection.style.display = "none";

        const limitedTimeOffer = countdownWrapper.closest('.limited-time-offer');
        if (limitedTimeOffer) limitedTimeOffer.style.display = "none";

        clearInterval(timerInterval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      splitDigits(countdownWrapper.querySelector('.countdown-days'), days);
      splitDigits(countdownWrapper.querySelector('.countdown-hours'), hours);
      splitDigits(countdownWrapper.querySelector('.countdown-minutes'), minutes);
      splitDigits(countdownWrapper.querySelector('.countdown-seconds'), seconds);
    }

    const timerInterval = setInterval(updateCountdown, 1000);
    updateCountdown();
  });
});

// var eventSlider = null;

// function initEventSlider() {
//   var $container = $('.event-detail-container');
//   var screenWidth = window.innerWidth;

//   if (screenWidth <= 1336) {
//     if (!$container.hasClass('flickity-enabled')) {
//       eventSlider = new Flickity($container[0], {
//         cellAlign: 'left',
//         contain: true,
//         pageDots: false,
//         prevNextButtons: false,
//         wrapAround: false,
//         autoPlay: false
//       });
//     }
//   } else {
//     if ($container.hasClass('flickity-enabled')) {
//       eventSlider.destroy();
//     }
//   }
// }

// $(document).ready(initEventSlider);
// $(window).on('resize', initEventSlider);

